<template>
	<div class="context-menu" ref="menu" v-show="isOpen" v-observe-visibility="visibilityChanged">
		<ul>
			<slot />
		</ul>
	</div>
</template>
<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import Popper from 'popper.js'
	import $sc from '~/plugins/shortcut.collection.js'

	export default {
		name: 'ContextMenu',
		props: {
			options: { type: Object },
			items: { type: Array },
			target: {}
		},
		data() {
			return {
				children: [],
				settings: {
					title: this.$t('nikan'),
					trackPointer: true,
					popper: {
						placement: 'bottom-end',
						positionFixed: true,
						modifiers: {
							preventOverflow: {
								boundariesElement: null
							}
						}
					}
				},
				isOpen: false,
				mouse: null,
				prevMouse: null
			}
		},
		computed: {
			menuItems() {
				return this.children
			},
			targetEl() {
				if (_.isFunction(this.target)) {
					return this.target()
				} else {
					return this.target
				}
			}
		},
		watch: {
			target: {
				handler(val) {
					this.initPopper()
				}
			}
		},
		created() {
			this.settings = _.extend({}, this.settings, this.options)
		},
		mounted() {
			this.initPopper()
		},
		methods: {
			initPopper() {
				if (!this.targetEl) {
					return
				}

				$(this.targetEl).mousedown(event => {
					if (event.which === 3) {
						this.mouse = {
							pageY: event.pageY,
							pageX: event.pageX
						}
					}
				})

				$(this.targetEl).on('contextmenu', e => {
					e.preventDefault()

					if (this.isOpen === false) {
						$('.context-menu:visible').hide()
					}

					this.isOpen = true
					this.createPopper()
				})

				$(document).on('click', this.closeContextMenu.bind(this))
			},
			destoryPopper() {
				$(this.targetEl).off('contextmenu')
			},
			closeContextMenu() {
				if (this.isOpen === true) {
					this.isOpen = false
					this.targetEl.focus()
					this.subscribeExitKeys(false)
				}
			},
			createPopper() {
				if (!this.targetEl) {
					return
				}

				const getBoundingClientRect = () => {
					let m

					if (this.prevMouse == null) {
						m = this.mouse == null ? { pageY: 0, pageX: 0 } : this.mouse
						this.prevMouse = m
					} else {
						m = this.prevMouse
						this.prevMouse = null
					}

					this.mouse = null

					return {
						top: m.pageY,
						right: m.pageX,
						bottom: m.pageY,
						left: m.pageX,
						width: 0,
						height: 0
					}
				}

				const ref = {
					getBoundingClientRect: getBoundingClientRect.bind(this),
					clientWidth: 0,
					clientHeight: 0
				}

				let reference = this.mouse == null ? this.targetEl : ref;
				(() => new Popper(reference, this.$refs.menu, this.settings.popper))()
				this.subscribeExitKeys(true)
			},
			visibilityChanged(isVisible, entry) {
				if (this.isOpen !== isVisible) {
					this.isOpen = isVisible
				}
			},
			subscribeExitKeys(enable) {
				if (enable) {
					this.$keyHandler.Subscribe({
						name: 'context-menu-exit',
						shortcut: $sc.find('exit'),
						el: this.targetEl,
						context: this,
						handler: function (sender, e) {
							if (this.isOpen) {
								this.closeContextMenu()
								return true
							}
						}
					})
				} else {
					this.$keyHandler.Unbind(this.targetEl)
				}
			}
		},
		beforeUnmount() {
			this.destoryPopper()
		}
	}
</script>
